<script setup lang="ts">
import { useRouter } from 'vue-router';
import signInImage from '@/images/account/sign-in.jpg';
import { AuthRouteName } from '@/js/account/app/router/route-names';
import AuthTitle from '@/js/account/components/auth/AuthTitle.vue';
import BaseButton from '@/js/account/components/base/BaseButton.vue';
import BaseIcon from '@/js/account/components/base/BaseIcon.vue';
import AuthLayout from '@/js/account/layouts/auth-layout/AuthLayout.vue';
import { classNames } from '@/js/lib/bem';

const router = useRouter();
const cn = classNames('password-changed-page');

function goToSignIn(): void {
  void router.push({ name: AuthRouteName.Login });
}
</script>

<template>
  <AuthLayout :src="signInImage" alt="">
    <div :class="cn()">
      <BaseIcon
        type="main"
        name="successfully"
        :class="cn('icon')"
        :width="100"
        :height="100"
      />
      <AuthTitle :class="cn('title')" title="Password changed successfully" />
      <BaseButton
        :class="cn('button')"
        type="button"
        full-width
        @click="goToSignIn"
      >
        Sign in
      </BaseButton>
    </div>
  </AuthLayout>
</template>

<style lang="scss" scoped>
.password-changed-page {
  max-width: 363px;
  width: 100%;
  text-align: center;

  &__icon {
    display: block;
    margin: 0 auto 32px;
  }

  &__title {
    margin-bottom: 40px;
    text-align: center;
  }

  &__button {
    margin-bottom: 40px;
  }
}
</style>
